import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { Breadcrumbs } from "components/search/Breadcrumbs";
import { H1 } from "components/core/Typography";
import { ClickToCall } from "components/brand/ClickToCall";
import Container from "components/core/Page/Container";
import { StarReviewsCount } from "components/review/StarReviewsCount";
import { getLocalNumber } from "store/modules/phone";
import "./FacilityPageHeader.scss";
import { Heading } from "components/storages/Common";

const FacilityPageHeader = ({
	location,
	cityUrl,
	url,
	stateUrl,
	name,
	address,
	reviews
}) => {
	const [phone, setPhone] = useState({});
	const dispatch = useDispatch();
	const handleFetchNumber = async ({ city, state }) => {
		const data = { path: `${city}/${state}` };
		const {
			payload: { result }
		} = await dispatch(getLocalNumber(data));
		setPhone(result);
		return result;
	};
	return (
		<Container className="facility-page-header">
			<Breadcrumbs
				location={location}
				cityUrl={cityUrl}
				facilityUrl={url}
				facilityName={name}
				stateUrl={stateUrl}
				allowTruncation
			/>
			<H1
				mediumSize="large"
				className="facility-name"
			>
				{name}
			</H1>
			<Heading
				content={address}
				level="2"
				size="standard"
				weight="regular"
				className="facility-address"
			/>
			<ClickToCall
				underline
				handleFetchNumber={() => handleFetchNumber(location)}
				phone={phone}
			/>
			<StarReviewsCount
				average={reviews.average}
				number={reviews.number}
				url="#reviews"
			/>
		</Container>
	);
};

FacilityPageHeader.propTypes = {
	name: PropTypes.string,
	address: PropTypes.string,
	reviews: PropTypes.object,
	url: PropTypes.string,
	location: PropTypes.object,
	cityUrl: PropTypes.string,
	stateUrl: PropTypes.string
};

export default FacilityPageHeader;
